import { connect } from "react-redux";
import CreateLob from "./CreateLob";
import { bindActionCreators } from "redux";
import { createLob } from "services/redux/Lob/action";

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      createLob,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CreateLob);
